var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 84,
    viewBox: "0 0 68 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 8.66683H0.666504V0.333496H67.3332V8.66683H58.9998V17.0002C58.9998 23.7293 55.5998 29.146 51.3165 33.571C48.3873 36.596 44.8248 39.3835 41.2123 42.0002C44.8248 44.6168 48.3873 47.4043 51.3165 50.4293C55.5998 54.8543 58.9998 60.271 58.9998 67.0002V75.3335H67.3332V83.6668H0.666504V75.3335H8.99984V67.0002C8.99984 60.271 12.3998 54.8543 16.6832 50.4293C19.6123 47.4043 23.1748 44.6168 26.7873 42.0002C23.1748 39.3835 19.6123 36.596 16.6832 33.571C12.3998 29.146 8.99984 23.7293 8.99984 17.0002V8.66683ZM17.3332 8.66683V17.0002C17.3332 19.8543 18.4165 22.5627 20.5457 25.3335H47.454C49.579 22.5627 50.6665 19.8543 50.6665 17.0002V8.66683H17.3332ZM33.9998 47.0918C29.6457 50.1668 25.6998 53.096 22.6707 56.2252C21.9167 56.9981 21.2072 57.8133 20.5457 58.6668H47.454C46.7924 57.8134 46.0829 56.9982 45.329 56.2252C42.2998 53.096 38.354 50.1668 33.9998 47.0918Z",
    fill: "#00B680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.7fb226fa9c1b2563fb4525935b7d9b7c.svg";
export { ForwardRef as ReactComponent };